/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import { indigo500, green500, deepOrange500, red500 } from 'material-ui/styles/colors'

/* Constants Workflow */
export const WORKFLOW_NAME = 'prestation_proposal_workflow'
export const NEW_PRESTATION_PROPOSAL_STATUS = 'new'
export const ACCEPT_PROPOSAL_ACTION = 'accepted'
export const REFUSE_PROPOSAL_ACTION = 'refused'
export const CANCELLED_PROPOSAL_ACTION = 'cancelled'

/* Constants */
export const APPLICANT_PROPOSAL_TYPE = 1
export const INTERPRETER_PROPOSAL_TYPE = 2
export const PRESTATION_PROPOSAL_STATUS_COLOR = {
  new: deepOrange500,
  accepted: green500,
  refused: red500,
  cancelled: indigo500
}



// WEBPACK FOOTER //
// ./src/constants/Proposal.js